import React, { useContext } from 'react';
import { Link } from '@hub/link';
import trackClickEvent from '../../../helpers/analytics-utils/track-event';
import EventNotification from '../../../components/event-notification';
import { CountryContext } from '../../../context';
import { H3 } from '@hub/heading';
import { Box } from '@hub/box';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const isService = (entries, contentTypes) => {
  return Boolean((contentTypes === null || contentTypes === void 0 ? void 0 : contentTypes.includes('Service')) || (entries === null || entries === void 0 ? void 0 : entries.find(entry => entry.contentTypeId === 'service')));
};
const showCovidNotification = (country, entries, contentTypes) => {
  return country === 'Australia' && isService(entries, contentTypes);
};
const Notification = _ref => {
  let {
    shortDescription,
    entries,
    contentTypes
  } = _ref;
  const country = useContext(CountryContext);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: shortDescription && showCovidNotification(country, entries, contentTypes) && /*#__PURE__*/_jsx(EventNotification, {
      sx: {
        color: 'quartz',
        textAlign: 'center',
        fontSize: ['font-sm', null, 'font-md'],
        marginTop: '-spacing-sm',
        marginBottom: 'spacing-sm'
      },
      message: shortDescription,
      "data-id": "spotlight_index_Notification_EventNotification"
    })
  });
};
const Spotlight = _ref2 => {
  let {
    children,
    heading,
    shortDescription,
    callToAction,
    contentTypes,
    entries
  } = _ref2;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      paddingY: ['spacing-none', null, null]
    },
    "data-id": "spotlight_index_Notification_Box",
    children: [/*#__PURE__*/_jsx(H3, {
      align: 'center',
      sx: {
        marginBottom: ['spacing-md', 'spacing-lg']
      },
      "data-id": "spotlight_index_Notification_Box_H3",
      children: heading
    }), /*#__PURE__*/_jsx(Notification, {
      shortDescription: shortDescription,
      contentTypes: contentTypes,
      entries: entries,
      "data-id": "spotlight_index_Box_Notification"
    }), children, callToAction && callToAction.address && /*#__PURE__*/_jsx(Box, {
      sx: {
        textAlign: 'center',
        paddingTop: ['spacing-lg', 'spacing-md']
      },
      "data-id": "spotlight_index_Notification_Box",
      children: /*#__PURE__*/_jsx(Link, {
        hasUnderline: true,
        href: callToAction.address,
        onClick: callToAction.eventCategory ? () => trackClickEvent(callToAction.eventCategory, callToAction.eventAction, callToAction.eventLabel) : () => void {},
        "data-id": "spotlight_index_Notification_Box_Link",
        children: callToAction.text
      })
    })]
  });
};
export default Spotlight;